import script from "./SceneImageToTap.vue?vue&type=script&lang=js"
export * from "./SceneImageToTap.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__